module.exports = __webpack_public_path__ + "static/media/carta_66.c58e28c6.jpg";